import styled from 'styled-components';
import { colors } from '~/layout';

export const Container = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;

  button {
    box-shadow: none;
    border: 0;
    text-align: center;
  }
`;

export const TextError = styled.div`
  text-align: center;
  font-size: ${props => (props.fontSize ? props.fontSize : 8)}px;
  color: ${colors.white};
  padding: 10px;
`;
